<ul class="nav custom-nav-tab">
    <li class="nav-item" role="presentation">
        <a href="javascript:void(0)" routerLinkActive="active" [routerLink]="[short_name , 'store']" class="nav-link"
            (click)="navigationClick('home-menu')" id="home-menu" type="button">Home</a>
    </li>
    <li class="nav-item" role="presentation">
        <a href="javascript:void(0)" class="nav-link" id="profile-menu" type="button">Join The EcoSystem</a>
    </li>
    <!-- <li class="nav-item" role="presentation">
        <a href="javascript:void(0)" class="nav-link" id="integration-menu" type="button">Suggest An Integration</a>
    </li> -->
    <!-- <li class="nav-item" role="presentation">
        <a href="javascript:void(0)" class="nav-link" id="accessories-menu" type="button">Phones & Accessories</a>
    </li> -->
    <li class="nav-item" role="presentation">
        <a href="https://docs.ns-api.com/reference/" target="_blank" class="nav-link" id="developer-menu" type="button">
            Developer Resources
        </a>
    </li>
    <li class="nav-item" role="presentation" *ngIf="!user" (click)="navigationClick('partreg-menu')">
        <a href="javascript:void(0)" class="nav-link" id="partreg-menu">
            CSP Registration
        </a>
    </li>
    <li class="nav-item" role="presentation" *ngIf="user && !isCustomerUser"
        (click)="navigationClick('auditlogs-menu')">
        <a href="javascript:void(0)" class="nav-link" id="auditlogs-menu" routerLinkActive="active"
            [routerLink]="[short_name , 'admin', 'auditLogs']">
            Audit Logs
        </a>
    </li>
    <li class="nav-item" role="presentation" *ngIf="user && !isCustomerUser"
        (click)="navigationClick('approvals-menu')">
        <a href="javascript:void(0)" class="nav-link" id="approvals-menu" routerLinkActive="active"
            [routerLink]="[short_name , 'admin', 'approvals']">
            Approvals
        </a>
    </li>
    <li class="nav-item nav-item-push-left" role="presentation" *ngIf="user && lastLoginDate">
        <a href="javascript:void(0)" class="nav-link">
            <span>Last Login:</span>&nbsp;<span>{{lastLoginDate}}</span>
        </a>
    </li>
</ul>